import { Injectable, signal } from '@angular/core';

const MOBILE_BREAKPOINT = 768;

@Injectable({ providedIn: 'root' })
export class LayoutStateService {
  readonly isMobile = signal(window.innerWidth < MOBILE_BREAKPOINT);
  readonly sidebarOpen = signal(!this.isMobile());

  constructor() {
    window.addEventListener('resize', () => this.onResize());
  }

  private onResize(): void {
    const mobile = window.innerWidth < MOBILE_BREAKPOINT;
    if (mobile !== this.isMobile()) {
      this.isMobile.set(mobile);
      this.sidebarOpen.set(!mobile);
    }
  }

  toggleSidebar(): void {
    this.sidebarOpen.update(v => !v);
  }

  openSidebar(): void {
    this.sidebarOpen.set(true);
  }

  closeSidebar(): void {
    this.sidebarOpen.set(false);
  }
}
